import * as z from 'zod/v4';

import { invertObject, zodEnumFromObjectKeys } from '../utils/entry.js';

export const RSYS_VARIANTS = {
  'R7-0-36': 28,
  'R8-0-81': 29,
  'R9-0-222': 30,
  'R10-0-567': 31,
  'R11-0-729': 32,
  'R0-7-16': 33,
  'R0-11-16': 34,
  'R2-5-12': 35,
  'R3-3-24': 36,
  'R4-0-9': 37,
  'R4-4-24': 38,
  'R4-4-144': 39,
  'R4-5-48': 40,
  'R4-6-24': 41,
  'R4-6-72': 42,
  'R4-7-48': 43,
  'R4-7-144': 44,
  'R5-0-18': 45,
  'R5-3-36': 46,
  'R5-5-108': 47,
  'R6-3-24': 48,
  'R6-3-72': 49,
  'R6-4-44': 50,
  'R7-2-34': 51,
  'R7-2-108': 52,
  'R8-0-27': 53,
  'R8-2-324': 54,
  'R8-3-504': 55,
  'R9-0-243': 56,
  'R9-0-1356': 57,
  'R10-0-153': 58,
} as const;

export const RSYS_NUM = z.enum(RSYS_VARIANTS);
export type RSYSNum = z.infer<typeof RSYS_NUM>;

export const RSYS = zodEnumFromObjectKeys(RSYS_VARIANTS);
export type RSYS = z.infer<typeof RSYS>;

export const RSYS_NUMBER_VARIANTS = invertObject<RSYS, RSYSNum>(RSYS_VARIANTS);

/**
 * Checks if a value is a RSYS number.
 *
 * @param value numerical value to check
 * @returns Returns true if the value is a valid RSYS number
 */
export function isRSYS(value: number): value is RSYSNum {
  return value in RSYS_NUMBER_VARIANTS;
}
